import type { ReactNode } from "react";

/**
 * Document template (product lock 2026-08-15, lock 2): Help and other prose surfaces.
 * The workbench's reading variant: TOC subrail + article + optional utility rail.
 * Pair with `stage: "stage"` in route-templates.ts.
 *
 * The article soft-caps at 76ch (the one place the width doctrine allows a cap) with
 * balanced margins, so ultrawide never strands the copy against a black void. The aside
 * is the "useful related rail" from the board's Help frame; below 1600px it follows the
 * article instead of claiming a column.
 */
export function DocumentLayout({
  toc,
  aside,
  children,
}: {
  /** Usually a ShellSubrail carrying the TOC; it portals to the shell's subrail cell. */
  toc?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="docl">
      {toc}
      <div className={aside !== undefined ? "docl__stage docl__stage--aside" : "docl__stage"}>
        <article className="docl__article prose">{children}</article>
        {aside !== undefined ? <aside className="docl__aside">{aside}</aside> : null}
      </div>
    </div>
  );
}
